import authSi from "./authSi";
import commonSi from "./commonSi";
import footerSi from "./footerSi";
import gallerySi from "./gallerySi";
import menuSi from "./menuSi";
import navigationSi from "./navigationSi";
import orderSi from "./orderSi";
import paymentSi from "./paymentSi";
import statisticsSi from "./statisticsSi";

const mainSi = {
    common: commonSi,
    navigation: navigationSi,
    menu: menuSi,
    statistics: statisticsSi,
    order: orderSi,
    payment: paymentSi,
    auth: authSi,
    gallery: gallerySi,
    footer: footerSi,
};

export default mainSi;
